@if (restrictionDetails$ | async; as restriction) {
  <ng-container *ngTemplateOutlet="restrictionDetails; context: { $implicit: restriction, loading: false }"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="restrictionDetails; context: { $implicit: null, loading: true }"></ng-container>
}

<ng-template #restrictionDetails [appTemplateContext]="restrictionDetailsContext" let-restriction let-loading="loading">
  <app-card-pages-breadcrumbs [loading]="loading" cardPage="restrictionDetails"></app-card-pages-breadcrumbs>

  <div class="entity-details-container card-account-details-page">
    <div class="details-section-title">
      <div class="title">
        <app-text-with-placeholder [showPlaceholder]="loading">Restriction Details</app-text-with-placeholder>
      </div>

      <div class="controls">
        <button
          rktButton
          btnType="link"
          class="control-btn"
          (click)="onEditBtnClick(restriction)"
          [disabled]="!!(loading | accessControl | async)"
        >
          Edit
        </button>
      </div>
    </div>

    <div class="details-row">
      <app-details-item
        [class]="pageClassPrefix + 'id'"
        [showPlaceholder]="loading"
        label="Restriction ID"
        [value]="restriction?.id || '' | rktShortId"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'financial-account-id'"
        [showPlaceholder]="loading"
        label="Financial Account ID"
        [value]="restriction?.financialAccountId || '' | rktShortId"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'type'"
        [showPlaceholder]="loading"
        label="Type"
        [value]="$safeNavigationMigration(restriction?.typeLabel)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'value'"
        [showPlaceholder]="loading"
        label="Value"
        [value]="$safeNavigationMigration(restriction?.value)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'mode'"
        [showPlaceholder]="loading"
        label="Mode"
        [value]="$safeNavigationMigration(restriction?.modeLabel)"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'enabled'"
        [showPlaceholder]="loading"
        label="Enabled"
        [value]="restriction?.active ? 'Yes' : 'No'"
      ></app-details-item>
    </div>

    <div class="details-separator"></div>

    <div class="details-row">
      <app-details-item
        [class]="pageClassPrefix + 'start-date'"
        [showPlaceholder]="loading"
        label="Start Date and Time"
        [noBreak]="true"
        [value]="$safeNavigationMigration(restriction?.startDateTime) | dateFormat"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'end-date'"
        [showPlaceholder]="loading"
        label="End Date and Time"
        [value]="$safeNavigationMigration(restriction?.endDateTime) | dateFormat"
      ></app-details-item>

      <app-details-item
        [class]="pageClassPrefix + 'operator'"
        [showPlaceholder]="loading"
        label="Operator"
        [value]="$safeNavigationMigration(restriction?.operatorLabel)"
      ></app-details-item>
    </div>

    <div class="details-separator"></div>

    <div class="create-update-section">
      <div class="details-row">
        <app-details-item
          [class]="pageClassPrefix + 'created-at'"
          [showPlaceholder]="loading"
          label="Created At"
          [value]="$safeNavigationMigration(restriction?.createdAt) | dateFormat"
        ></app-details-item>

        <app-details-item
          [class]="pageClassPrefix + 'created-by'"
          [showPlaceholder]="loading"
          label="Created By"
          [value]=""
        ></app-details-item>
      </div>

      <div class="details-row">
        <app-details-item
          [class]="pageClassPrefix + 'updated-at'"
          [showPlaceholder]="loading"
          label="Updated At"
          [value]="$safeNavigationMigration(restriction?.updatedAt) | dateFormat"
        ></app-details-item>

        <app-details-item
          [class]="pageClassPrefix + 'updated-by'"
          [showPlaceholder]="loading"
          label="Updated By"
          [value]=""
        ></app-details-item>
      </div>
    </div>
  </div>
</ng-template>
